import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, message } from 'hljd'
import style from './style.module.less'
import { Input } from 'hljd'
import { observer, inject } from 'mobx-react'
import {
  FOLLOW_STATUS_ING,
  FOLLOW_STATUS_NOT
} from '@components/JiaMeng/NewCustomer/constant'
import { Flex } from 'hljd'
import modalStyle from '@components/JiaMeng/NewCustomer/style/modal.css'

@Form.create()
@inject('detailStore')
@observer
class FollowModal extends Component {
  notFollow = () => {
    const {
      form: { getFieldsValue }
    } = this.props
    const { reason } = getFieldsValue()

    if (!reason) {
      return message.warn('请输入理由')
    }

    const {
      followModalStore: { setFollowStatus }
    } = this.props.detailStore
    setFollowStatus({ follow_status: FOLLOW_STATUS_NOT, reason })
  }

  follow = () => {
    const {
      followModalStore: { setFollowStatus }
    } = this.props.detailStore
    setFollowStatus({ follow_status: FOLLOW_STATUS_ING })
  }

  render() {
    const {
      form: { getFieldDecorator, setFieldsValue, getFieldValue }
    } = this.props
    const {
      followModalStore,
      isNotFollow,
      customerName
    } = this.props.detailStore
    const { followModalVisible, setStoreData } = followModalStore

    return (
      <Modal
        title={isNotFollow ? '确认重新跟进此客户' : '确认不再跟进此客户'}
        visible={followModalVisible}
        onOk={isNotFollow ? this.follow : this.notFollow}
        onCancel={() => setStoreData({ followModalVisible: false })}
        destroyOnClose={true}
        width={400}
        wrapClassName={style.modal}
      >
        {isNotFollow ? (
          <div>客户名：{customerName}</div>
        ) : (
          <Form className={modalStyle.form}>
            <Form.Item label="客户名">{customerName}</Form.Item>

            <Form.Item label="理由">
              {getFieldDecorator('reason', {
                initialValue: ''
              })(<Input.TextArea />)}
            </Form.Item>

            <Form.Item label="快捷输入">
              <Flex className={style.value}>
                {[
                  { id: 1, value: '无意向' },
                  { id: 2, value: '已购买' },
                  { id: 3, value: '反感致电' }
                ].map(({ id, value }) => (
                  <div
                    key={id}
                    className={style.btn}
                    onClick={() => {
                      const data = getFieldValue('reason')
                      setFieldsValue({
                        reason: data.concat(value)
                      })
                    }}
                  >
                    {value}
                  </div>
                ))}
              </Flex>
            </Form.Item>
          </Form>
        )}
      </Modal>
    )
  }
}

export default FollowModal
